import {
  DELETE_EXEMPTION_MUTATION,
  EDIT_EXEMPTION,
  RESET_EXEMPTION_MODULE,
  RESET_INTERVENTION_MODULE,
  SET_DRAWER_STATE,
  SET_EXEMPTION_END_DATE,
  SET_EXEMPTION_END_DISABLED,
  SET_EXEMPTION_ERROR,
  SET_EXEMPTION_ID,
  SET_EXEMPTION_REASON,
  SET_EXEMPTION_REASONS_LIST,
  SET_EXEMPTION_SENDING,
  SET_EXEMPTION_START_DATE,
  SET_EXEMPTION_START_DISABLED,
  SET_INFORMATION_SNACKBAR_STATE,
  SET_INFORMATION_SNACKBAR_TEXT,
  UPDATE_EXEMPTION_MUTATION,
  SET_DRAWER_COMPONENT,
  SET_GROUP_LOADING
} from '../mutation-types'
import {
  CREATE_EXEMPTION, CREATE_GROUP_EXEMPTION,
  DELETE_EXEMPTION,
  REPLACE_STUDENT_INTERACTIONS,
  UPDATE_EXEMPTION,
  UPDATE_INTERACTIONS_PAGE
} from '../action-types'
import { informationTexts } from './information'
import server from '../server'
import moment from 'moment-es6'
import axios from 'axios/index'

const variableLists = {
  exemptionReasons: []
}

const state = () => ({
  currentExemptionReason: null,
  startDate: moment().format('YYYY-MM-DD'),
  endDate: moment().format('YYYY-MM-DD'),
  startDateDisabled: false,
  endDateDisabled: false,
  exemptionId: null,
  sending: false,
  errorMessage: ''
})

const mutations = {
  [SET_EXEMPTION_REASONS_LIST] (state, list) {
    state.exemptionReasons = list.filter(item => item.enabled).map(mapServerToLocal)
  },
  [EDIT_EXEMPTION] (state, payload) {
    state.currentExemptionReason = payload.reasonId
  },
  [SET_EXEMPTION_REASON] (state, value) {
    state.currentExemptionReason = value
  },
  [SET_EXEMPTION_START_DATE] (state, value) {
    state.startDate = value
  },
  [SET_EXEMPTION_END_DATE] (state, value) {
    state.endDate = value
  },
  [SET_EXEMPTION_START_DISABLED] (state, value) {
    state.startDateDisabled = value
  },
  [SET_EXEMPTION_END_DISABLED] (state, value) {
    state.endDateDisabled = value
  },
  [SET_EXEMPTION_ID] (state, value) {
    state.exemptionId = value
  },
  [SET_EXEMPTION_SENDING] (state, value) {
    state.sending = value
  },
  [SET_EXEMPTION_ERROR] (state, errorMessage = '') {
    state.errorMessage = errorMessage
  },
  [RESET_EXEMPTION_MODULE] (s) {
    const initial = state()
    Object.keys(initial).forEach(key => { s[key] = initial[key] })
  }
}

const actions = {
  [CREATE_EXEMPTION] ({rootState, commit, dispatch}, payload) {
    const actionData = { action: CREATE_EXEMPTION, data: payload }
    commit(SET_EXEMPTION_SENDING, true)
    server.postReplayable(`/core/exemption/${payload.studentId}`, payload, actionData)
      .then((res) => {
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.EXEMPTION_CREATED)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
        commit(SET_DRAWER_COMPONENT, null)
        commit(SET_DRAWER_STATE, false)
        commit(RESET_INTERVENTION_MODULE)
        commit(SET_EXEMPTION_SENDING, false)
        commit(SET_EXEMPTION_ERROR)
        dispatch(UPDATE_INTERACTIONS_PAGE)
        const studentId = rootState.student.student.id
        if (studentId && payload.studentId === studentId) {
          dispatch(REPLACE_STUDENT_INTERACTIONS, studentId)
        }
      })
      .catch((err) => {
        console.error(err)
        commit(SET_EXEMPTION_ERROR, flattenError(err.response.data))
        commit(SET_EXEMPTION_SENDING, false)
      })
  },
  [CREATE_GROUP_EXEMPTION] ({commit, dispatch}, payload) {
    const actionData = { action: CREATE_GROUP_EXEMPTION }
    const url = `/core/exemption/bulk/${payload.myGroupId}`
    commit(SET_GROUP_LOADING, true)
    commit(SET_EXEMPTION_SENDING, true)
    server.postReplayable(url, payload, actionData)
      .then(result => {
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.GROUP_EXEMPTION_CREATED)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
        commit(SET_DRAWER_COMPONENT, null)
        commit(SET_DRAWER_STATE, false)
        commit(RESET_INTERVENTION_MODULE)
        commit(SET_EXEMPTION_SENDING, false)
        commit(SET_EXEMPTION_ERROR)
        commit(SET_GROUP_LOADING, false)
        dispatch(UPDATE_INTERACTIONS_PAGE)
      }).catch(error => {
        console.error(error)
        commit(SET_EXEMPTION_ERROR, flattenError(error.response.data))
        commit(SET_EXEMPTION_SENDING, false)
        commit(SET_GROUP_LOADING, false)
      })
  },
  [UPDATE_EXEMPTION] ({rootState, commit, dispatch}, payload) {
    const actionData = { action: UPDATE_EXEMPTION, data: payload }
    commit(SET_EXEMPTION_SENDING, true)
    server.putReplayable(`/core/exemption/${payload.exemptionId}`, payload, actionData)
      .then((res) => {
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.EXEMPTION_UPDATED)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
        commit(SET_DRAWER_COMPONENT, null)
        commit(SET_DRAWER_STATE, false)
        commit(RESET_INTERVENTION_MODULE)
        commit(SET_EXEMPTION_SENDING, false)
        commit(UPDATE_EXEMPTION_MUTATION, res.data)
        commit(SET_EXEMPTION_ERROR)
        dispatch(UPDATE_INTERACTIONS_PAGE)
      })
      .catch((err) => {
        console.error(err)
        commit(SET_EXEMPTION_ERROR, flattenError(err.response.data))
        commit(SET_EXEMPTION_SENDING, false)
      })
  },
  [DELETE_EXEMPTION] ({rootState, commit}, id) {
    const instance = axios.create()
    instance.defaults.baseURL = `${rootState.config.baseUrl}:${rootState.config.port}/core`
    instance.defaults.headers = {
      'Authorization': rootState.profile.loginToken
    }
    instance.defaults.actionData = { action: DELETE_EXEMPTION, data: id }

    instance.delete(`exemption/${id}`)
      .then((res) => {
        commit(DELETE_EXEMPTION_MUTATION, id)
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.EXEMPTION_DELETED)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
      })
      .catch((err) => {
        console.error(err)
        commit(SET_EXEMPTION_SENDING, false)
      })
  }
}

function mapServerToLocal (object) {
  return {
    text: object.description,
    value: object.id
  }
}

function flattenError (exemptionError) {
  return {
    type: exemptionError.childErrors ? exemptionError.childErrors[0].errorType : exemptionError.errorType,
    data: exemptionError.childErrors ? exemptionError.childErrors[0].errorData : exemptionError.errorData
  }
}

export default {
  state: Object.assign({}, state(), variableLists),
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/exemptionModule.js